/**
 * Query parameters for paged history API endpoints
 */
export interface HistoryPagedParams {
  /** If true, excludes history entries created by system user */
  skipSystemUpdate?: boolean;
  /** ISO date string for start of date range filter */
  sinceDatetimeUtc?: string;
  /** ISO date string for end of date range filter */
  tillDatetimeUtc?: string;
  /** Number of items per page (1-100, default: 10) */
  pageSize?: number;
  /** Page number (1-based, default: 1) */
  pageNumber?: number;
  /** Sort order (default: 'desc') */
  sortOrder?: 'asc' | 'desc';
}

/**
 * Standard paged response structure from API
 */
export interface PagedResponse<T> {
  currentPage: number;
  currentPageNumOfItems: number;
  totalPages: number;
  totalItems: number;
  items: T[];
}

/**
 * Helper to build query string from params
 */
export function buildHistoryQueryString(params?: HistoryPagedParams): string {
  if (!params) return '';
  
  const searchParams = new URLSearchParams();
  
  if (params.skipSystemUpdate !== undefined) {
    searchParams.set('skipSystemUpdate', String(params.skipSystemUpdate));
  }
  if (params.sinceDatetimeUtc) {
    searchParams.set('sinceDatetimeUtc', params.sinceDatetimeUtc);
  }
  if (params.tillDatetimeUtc) {
    searchParams.set('tillDatetimeUtc', params.tillDatetimeUtc);
  }
  if (params.pageSize !== undefined) {
    searchParams.set('pageSize', String(params.pageSize));
  }
  if (params.pageNumber !== undefined) {
    searchParams.set('pageNumber', String(params.pageNumber));
  }
  if (params.sortOrder) {
    searchParams.set('sortOrder', params.sortOrder);
  }
  
  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : '';
}

/** Default params for non-admin consumers */
export const NON_ADMIN_HISTORY_DEFAULTS: HistoryPagedParams = {
  skipSystemUpdate: true,
  sortOrder: 'desc',
  pageSize: 20,
  pageNumber: 1,
};

/** Default params for admin consumers */
export const ADMIN_HISTORY_DEFAULTS: HistoryPagedParams = {
  skipSystemUpdate: false,
  sortOrder: 'desc',
  pageSize: 25,
  pageNumber: 1,
};

